/**
 * styles.ts
 *
 * Author: Maurice T. Meyer
 * E-Mail: maurice@lavireo.com
 *
 * (c) Laviréo. All rights reserved.
 *
 * This document is the property of Laviréo.
 * It is considered confidential and proprietary.
 *
 * This document may not be reproduced or transmitted in any form,
 * in whole or in part, without the express written permission of
 * Laviréo.
 */

import { css } from '@emotion/react';

export const styles = {
  container: css({
    width: '100%',
  }),
  
  content: css({
    // minHeight: 540
    paddingBottom: 16
  }),

  navigation: css({
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',

    ':before': {
      display: 'none',
    },

    ':after': {
      display: 'none',
    }
  }),

  header: css({
    paddingBottom: 48
  }),

  title: css({
    fontSize: '32px',
    lineHeight: '40px',
    fontWeight: 500,
    color: 'rgb(0, 0, 0)',
    marginBottom: 8
  })
}